var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-card" },
    [
      _c(
        "template-card-v2",
        {
          attrs: {
            oneLog: _vm.oneLog,
            linkedtype: _vm.linkedtype,
            linkedid: _vm.linkedid,
            isDocument: _vm.isDocument,
            overviewType: _vm.overviewType
          }
        },
        [
          _c(
            "template",
            { slot: "icon" },
            [
              _vm.emailStatus.includes(_vm.oneLog.email.status)
                ? _c("CompassObject", {
                    attrs: { object: "sent-email", size: "small" }
                  })
                : ["replied", "received"].includes(_vm.oneLog.email.status)
                ? _c("CompassObject", {
                    attrs: { object: "inbox-email", size: "small" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          ["replied", "received"].includes(_vm.oneLog.email.status)
            ? _c("template", { slot: "label" }, [
                _vm.oneLog.email.from
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "semibold gray-80 fs-2 email-card-status-sender__label"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$l10n.__("De : %(emailSender)s", {
                                emailSender: _vm.oneLog.email.from.email
                              })
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm.oneLog.owner
            ? _c("template", { slot: "label" }, [
                _c(
                  "div",
                  { staticClass: "email-label-container" },
                  [
                    _c("person-list-light", {
                      attrs: { list: [_vm.oneLog.owner] }
                    }),
                    _vm._v(" "),
                    _c("email-statuses", {
                      attrs: { emailInfo: _vm.oneLog.email }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "email-card__content",
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _vm.isFailedToSend
                ? _c("CompassAlert", {
                    attrs: {
                      type: "error",
                      description: _vm.errorText,
                      showIcon: "",
                      action: {
                        label: _vm.errorButtonText,
                        callback: function() {
                          return _vm.resendEmail()
                        }
                      },
                      showClose: false
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isScheduledToBeSent
                ? _c("CompassAlert", {
                    attrs: {
                      type: "neutral",
                      size: "small",
                      description: _vm.scheduledAlertDescriptionLabel,
                      showClose: false,
                      showIcon: false,
                      action: {
                        label: _vm.scheduledAlertActionLabel,
                        callback: function() {
                          return _vm.cancelSendElement(_vm.oneLog)
                        }
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMocked || _vm.isScheduledToBeSent
                ? _c(
                    "p",
                    {
                      staticClass:
                        "typographies-paragraph-medium-regular email-subject"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.oneLog.email.subject) +
                          "\n            "
                      )
                    ]
                  )
                : _c("CompassLink", {
                    attrs: { label: _vm.oneLog.email.subject },
                    on: {
                      click: function($event) {
                        return _vm.openEmailPanel(_vm.oneLog)
                      }
                    }
                  }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "typographies-paragraph-medium-regular email-description",
                class: _vm.editorClass,
                domProps: { innerHTML: _vm._s(_vm.descriptionEmail) }
              }),
              _vm._v(" "),
              _vm.attachmentsCount > 0
                ? _c("div", { staticClass: "email-card__attachments" }, [
                    _c(
                      "div",
                      { staticClass: "email-card__attachments-list" },
                      [
                        _vm._l(_vm.attachmentsList, function(attachment) {
                          return _c("EmailAttachmentLink", {
                            key: attachment.id,
                            attrs: { file: attachment, isMocked: _vm.isMocked }
                          })
                        }),
                        _vm._v(" "),
                        _vm.attachmentsCount > 3 &&
                        !_vm.isAttachmentsListExtended
                          ? _c(
                              "button",
                              {
                                staticClass: "email-attachment-show-more",
                                on: { click: _vm.handleShowMoreClick }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "email-attachment-show-more__label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formattedAttachmentsShowMoreCount
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showConversationButton
                ? _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("timeline.EmailCardV2.display_email"),
                      type: "secondary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.openEmailPanel(_vm.oneLog)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "more" }, slot: "more" })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }